import React, { } from 'react';
import { Card, CardBody, Col, Container, Row} from "reactstrap";
import btnLanjut from '../../../assets/images/game/w2_buttons/Lanjut.png'
import imgGuide1 from '../../../assets/images/game/w2_gift/W2GIF-1.gif'
import imgGuide2 from '../../../assets/images/game/w2_gift/W2GIF-2.gif'
import imgGuide3 from '../../../assets/images/game/w2_gift/W2GIF-3.gif'

const GuidePermainan = ({ scrollEvents }) => {
    return (
        <>
            <Container className="h-100 py-5 front">
                <Row className="h-100">
                    <Col md="12" className="text-center game-px">
                        <h2 className="judul-game-2 marko-one text-white mb-5">
                            Peraturan Permainan
                        </h2>
                        <Card className="card-game mb-3">
                            <CardBody>
                                <Row>
                                    <Col md="2" className="d-flex justify-content-center align-self-center">
                                        <img src={imgGuide1} alt="clicked" className="img-fluid" />
                                    </Col>
                                    <Col md="10" className="d-flex justify-content-start align-self-center text-start pr-5">
                                        <span className="text-dark">
                                            Cari dan klik jawaban yang menurutmu sesuai dengan pertanyaan atau studi kasus yang ditampilkan.
                                        </span>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="card-game mb-3">
                            <CardBody>
                                <Row>
                                    <Col md="2" className="d-flex justify-content-center align-self-center">
                                        <img src={imgGuide2} alt="clicked" className="img-fluid" />
                                    </Col>
                                    <Col md="10" className="d-flex justify-content-start align-self-center text-start pr-5">
                                        <span className="text-dark">
                                            Pastikan semua pertanyaan telah kamu jawab dan tidak terlewat.
                                        </span>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="card-game mb-3">
                            <CardBody>
                                <Row>
                                    <Col md="2" className="d-flex justify-content-center align-self-center">
                                        <img src={imgGuide3} alt="clicked" className="img-fluid" />
                                    </Col>
                                    <Col md="10" className="d-flex justify-content-start align-self-center text-start pr-5">
                                        <span className="text-dark">
                                            Setelah memilih jawaban, akan muncul pembenaran jawabanmu langsung.
                                        </span>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <button onClick={scrollEvents} className="border-0 bg-transparent my-4"><img src={btnLanjut} alt="Mulai Game" className="btn-mulai-game" /></button>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default GuidePermainan